@if (isAlertBox) {
  <div>
    <ob-alert type="info">{{ translateKey | translate }}</ob-alert>
  </div>
} @else {
  <div class="info">
    <div [innerHTML]="translateKey | translate"></div>
    @if (allowDialogBox) {
      <p class="pdb-15" ><button mat-button obButton="secondary" (click)="dialog.open(helpDialog)" class="action-button-btn">{{translateKey4HelpBtntxt | translate}}</button></p>
    }
  </div>
}



<ng-template #helpDialog>
  <div [innerHTML]="translateKey4HelpTxt | translate"
  style="color:#263645;margin-bottom: 10px;"></div>
  <button mat-button obButton="secondary" id="btn_close-dialog" mat-dialog-close class="action-button-btn">
    <span translate>i18n.common.close</span>
  </button>
</ng-template>
